import React, { useState } from "react";
import { TableDateRange } from "../../common/components/TableDateRange";
import { useQuery } from "react-query";
import { AxiosAreasAPI } from "../Api";
import { Loader } from "semantic-ui-react";
import { ErrorSegment } from "../../common/components/ErrorSegment";

const AreaHistoryTable = ({ arearecord_set, ordering, setOrdering }) => {
  const rows = arearecord_set.map((el) => ({
    id: el.id,
    startDate: el.timespan.lower,
    endDate: el.timespan.upper,
  }));

  return (
    <TableDateRange data={rows} ordering={ordering} setOrdering={setOrdering} />
  );
};

export const AreaHistoryList = ({ area_id }) => {
  const [ordering, setOrdering] = useState(null);

  const { data, error } = useQuery(["areaRecords", area_id, ordering], () =>
    AxiosAreasAPI.getRecords(area_id, ordering),
  );

  if (error) return <ErrorSegment message={error.message} />;
  if (data === undefined) return <Loader active />;
  if (data)
    return (
      <AreaHistoryTable
        arearecord_set={data.results}
        ordering={ordering}
        setOrdering={setOrdering}
      />
    );

  return null;
};
